<div class="custom-snackbar-container">
    <!-- Contenido principal del snackbar -->
    <div class="snackbar-main-content">
        <div [ngClass]="{
            'circle': true,
            'complete-circle': data.type === 'COMPLETE',
            'error-circle': data.type === 'FAILED',
            'warn-circle': data.type === 'WARN'
          }">
          @switch (data.type) {
            @case ('COMPLETE') {
                <ng-container class="complete-circle" >
                    <mat-icon>task_alt_outlined</mat-icon>
                </ng-container>
            }
            
            @case ('FAILED') {
                <ng-container class="error-circle" >
                    <img src="../../../../../assets/svg/alert.svg" alt="Icon alert">
                </ng-container>
            }
            @case ('WARN') {
                <ng-container class="warn-circle" >
                    <img src="../../../../../assets/icons/warn.svg" alt="Icon alert">
                </ng-container>
            }
            @default {
                <ng-container class="warn-circle" >
                    <img src="../../../../../assets/icons/warn.svg" alt="Icon alert">
                </ng-container>
            }
        }
           
        </div>    
                
        <div class="snack-body">
            <strong class="mb-2">{{data.title}}</strong>
            <span class="mb-2">{{data.subtitle}}</span>
        </div>

        <div class="ml-2">
            <button mat-icon-button (click)="closeSnackBar()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    
    <!-- Barra de progreso en la parte inferior -->
    <div class="progress-container">
        <mat-progress-bar 
            class="timer-bar"
            mode="determinate" 
            [value]="progressValue">
        </mat-progress-bar>
    </div>
</div>